var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M11.454 2.267a9.307 9.307 0 1 0 9.307 9.306 9.317 9.317 0 0 0-9.307-9.306m.716 17.148v-5.694h2.148a.716.716 0 1 0 0-1.432H12.17v-2.147a1.43 1.43 0 0 1 1.432-1.432h1.432a.716.716 0 0 0 0-1.432h-1.432a2.864 2.864 0 0 0-2.864 2.864v2.147H8.59a.716.716 0 0 0 0 1.432h2.148v5.694a7.875 7.875 0 1 1 1.432 0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.909v23.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.909v23.727H0z"
  })))));
};
export default SvgFacebook;